/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/

/*CONST*/

class COLLAB_BLOCK_EDITOR extends Component {
  render() {
    return (
      <main className="main_container">
        <section
          className="container background_white outline_shadow_soft"
          style={{ width: "500px", maxWidth: "100%" }}
        >
          <p className="text_bold sub_color">
            Ini data privat. Silakan masuk atau daftar untuk mengaksesnya.
          </p>
        </section>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(COLLAB_BLOCK_EDITOR);
